<section id="dynamic-category-toolbar-55555" class="style-dynamic-category-toolbar-55555">
    <div class="sorting-layout-1 sorting-layout-background sorting-layout-border-color sorting-layout-border-top-left-radius sorting-layout-border-top-right-radius sorting-layout-border-bottom-left-radius sorting-layout-border-bottom-right-radius editable">
        <div class="hide-on-mobile">
            <div class="grid-handler-panel">
                <p class="grid-handler-text-size grid-handler-text-color grid-handler-font-weight grid-handler-text-transform">
                    View as:
                </p>

                @if (categoryLayoutData()?.categoryLayoutConfig?.categoryLayoutType !==
                LAYOUT_TYPE.Layout_02) {
                <div class="grid-handler-option-1" (click)="changeItemGridView(gridViewLayout.GRID_VIEW_LAYOUT1)">
                    <span class="grid-handler-option-tile grid-handler-option-tile-color" [class.grid-handler-option-active]="
              selectedGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT1
            "></span>
                    <span class="grid-handler-option-tile grid-handler-option-tile-color" [class.grid-handler-option-active]="
              selectedGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT1
            "></span>
                </div>
                }

                <div class="grid-handler-option-2" (click)="changeItemGridView(gridViewLayout.GRID_VIEW_LAYOUT2)">
                    <span class="grid-handler-option-tile grid-handler-option-tile-color" [class.grid-handler-option-active]="
              selectedGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT2
            "></span>
                    <span class="grid-handler-option-tile grid-handler-option-tile-color" [class.grid-handler-option-active]="
              selectedGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT2
            "></span>
                    <span class="grid-handler-option-tile grid-handler-option-tile-color" [class.grid-handler-option-active]="
              selectedGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT2
            "></span>
                </div>

                @if (categoryLayoutData().categoryLayoutConfig.categoryLayoutType === LAYOUT_TYPE.Layout_02)
                {
                <div class="grid-handler-option-4" (click)="changeItemGridView(gridViewLayout.GRID_VIEW_LAYOUT4)">
                    <span class="grid-handler-option-tile grid-handler-option-tile-color" [class.grid-handler-option-active]="
              selectedGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT4
            "></span>
                    <span class="grid-handler-option-tile grid-handler-option-tile-color" [class.grid-handler-option-active]="
              selectedGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT4
            "></span>
                    <span class="grid-handler-option-tile grid-handler-option-tile-color" [class.grid-handler-option-active]="
              selectedGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT4
            "></span>
                    <span class="grid-handler-option-tile grid-handler-option-tile-color" [class.grid-handler-option-active]="
              selectedGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT4
            "></span>
                </div>
                }

                <div class="grid-handler-option-3" (click)="changeItemGridView(gridViewLayout.GRID_VIEW_LAYOUT3)">
                    <span class="grid-handler-option-tile grid-handler-option-tile-color" [class.grid-handler-option-active]="
              selectedGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT3
            "></span>
                    <span class="grid-handler-option-tile grid-handler-option-tile-color" [class.grid-handler-option-active]="
              selectedGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT3
            "></span>
                    <span class="grid-handler-option-tile grid-handler-option-tile-color" [class.grid-handler-option-active]="
              selectedGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT3
            "></span>
                </div>
            </div>
        </div>

        <div class="show-on-mobile">
            <button class="open-mobile-filter open-mobile-filter-text-size open-mobile-filter-text-color open-mobile-filter-font-weight open-mobile-filter-text-transform" (click)="toggleHamburgerMenu()">
                {{
          currentAppliedFilters()?.length
            ? 'Filter (' + currentAppliedFilters()?.length + ')'
            : 'Filter (0)'
        }}
            </button>
        </div>

        <div class="sort-by-panel">
            <span class="sort-by-panel-text-size sort-by-panel-text-color sort-by-panel-font-weight sort-by-panel-text-transform">Sort by:</span>
            <div class="sort-by-select-dropdown">
                <select class="sort-by-select-dropdown-text-size sort-by-select-dropdown-text-color sort-by-select-dropdown-font-weight sort-by-select-dropdown-text-transform sort-by-select-dropdown-background sort-by-dropdown-border-color sort-by-dropdown-border-top-left-radius sort-by-dropdown-border-top-right-radius sort-by-dropdown-border-bottom-left-radius sort-by-dropdown-border-bottom-right-radius" [value]="sortBy()" (change)="onSortChange($event)">
                    @for (option of sortOptions(); track option.value) {
                    <option [value]="option?.value">
                        {{ option?.viewValue }}
                    </option>
                    }
                </select>

                <div class="sort-arrow-down sort-arrow-down-color"></div>
            </div>
        </div>
    </div>

    @if (isHamburgerMenu) {
    <div #changeHeaderMobileElement class="filter-mobile-panel" (click)="toggleHamburgerMenu()">
        <div class="filter-mobile-menu" (click)="$event.stopPropagation()" [ngStyle]="{ backgroundColor: getMobileFilterBackground() }">
            <!-- filter layout -->
            @switch (categoryLayoutData()?.categoryLayoutConfig?.categoryLayoutType) { @case
            (LAYOUT_TYPE.Layout_01) {
            <category-filter-layout-1 [category]="category()" [availableFilterAttributes]="availableFilterAttributes()" [currentAppliedFilters]="currentAppliedFilters()"></category-filter-layout-1>
            } @case (LAYOUT_TYPE.Layout_02) {
            <app-category-filter-layout-2 [category]="category()" [availableFilterAttributes]="availableFilterAttributes()" [currentAppliedFilters]="currentAppliedFilters()">
            </app-category-filter-layout-2>
            } @case (LAYOUT_TYPE.Layout_03) {
            <category-filter-layout-1 [category]="category()" [availableFilterAttributes]="availableFilterAttributes()" [currentAppliedFilters]="currentAppliedFilters()"></category-filter-layout-1>
            } }
        </div>
    </div>
    }
</section>